import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router';
import _ from 'lodash';
import Icon from 'components/Icon';
import Style from '../VideoModal.module.scss';
import { getActionButtons } from '../VideoModalHelpers';

export default function ActionButtons({ videoData = null }) {
  const actionButtons = getActionButtons(videoData);
  return (
    <div className={Style.actionButtons}>
      {_.map(actionButtons, ({ icon, viewBox, text, url }) => {
        if (!text) return null;
        const iconElement = icon && (
          <Icon className={Style.actionButtonIcon} icon={icon} viewBox={viewBox} color="white" />
        );
        return (
          <Link key={text} className={Style.actionButton} to={url}>
            {iconElement}
            {text}
          </Link>
        );
      })}
    </div>
  );
}

ActionButtons.propTypes = {
  videoData: PropTypes.shape({}),
};
